/* Copyright 2012-2018 The MathWorks, Inc. */

/**
 * The toolstrip can be in one of 3 display states: COLLAPSED, EXPANDED or EXPANDED_ON_TOP.
 */

define([], function () {
    return {
        COLLAPSED: "collapsed",
        EXPANDED: "expanded",
        EXPANDED_ON_TOP: "expanded_on_top",
        STATIC: "static"
    };
});